import { h, r as registerInstance, g as getElement } from './index-5faac9d7.js';
import { a2 as ECommercialStatus } from './currency-49e0d692.js';
import { t as tryParse } from './index-39f51a91.js';
import './_commonjsHelpers-7db8bc26.js';
import './analytics-b3108572.js';
import './lodash-7f024380.js';
import './_nodeUtil-549406aa.js';
import './_Stack-cf94d4e7.js';

const DEFAULT_SELECT_KEY = 'ALL';

const formAToZRangeGroupItems = (rangeObject) => {
  return Object.keys(rangeObject).map((rangeKey) => ({
    rangeGroupId: rangeKey === null || rangeKey === void 0 ? void 0 : rangeKey.toUpperCase(),
    rangeData: rangeObject[rangeKey],
  }));
};
const flattenAToZRangeItems = (parsedAtoZRangeItems) => {
  return Object.values(parsedAtoZRangeItems).flatMap(formAToZRangeGroupItems);
};
const extendAToZRangeItemsWithColor = (parsedAtoZRangeItems, rangeStatusColorMap) => {
  const rangeItems = flattenAToZRangeItems(parsedAtoZRangeItems);
  return rangeItems.map((rangeCategoryData) => {
    rangeCategoryData === null || rangeCategoryData === void 0 ? void 0 : rangeCategoryData.rangeData.map((rangeObject) => {
      const commercialStatus = rangeObject.status.toLowerCase();
      rangeObject.color = rangeStatusColorMap[commercialStatus];
      return rangeObject;
    });
    return rangeCategoryData;
  });
};
const createCommercialStatusObject = (rangeStatus, data) => {
  const commercialStatusObject = {
    labelName: '',
    color: data.rangeStatusColorMap[rangeStatus],
    commercialStatus: rangeStatus.toUpperCase(),
  };
  switch (rangeStatus.toUpperCase()) {
    case ECommercialStatus.END_OF_COMMERCIALIZATION_ANNOUNCED:
      commercialStatusObject.labelName = data.endOfCommercializationLabel;
      break;
    case ECommercialStatus.LEGACY:
      commercialStatusObject.labelName = data.legacyColorLabel;
      break;
    case ECommercialStatus.PRECOMMERCIALIZED:
      commercialStatusObject.labelName = data.preCommercializationLabel;
      break;
    default:
      commercialStatusObject.labelName = '';
  }
  return commercialStatusObject;
};
const getCommercialStatusArray = (data) => {
  if (!(data === null || data === void 0 ? void 0 : data.rangeStatusColorMap))
    return [];
  const commercialStatusColorKeysArray = Object.keys(data.rangeStatusColorMap);
  return commercialStatusColorKeysArray
    .map((rangeStatus) => createCommercialStatusObject(rangeStatus, data));
};

const ProductAtoZRanges = ({ rangesData = [] }) => {
  return (h("ul", { class: "product-finder-result" }, rangesData.map(({ rangeGroupId, rangeData }) => {
    return (h("li", { key: rangeGroupId },
      h("span", { class: "product-finder-result__heading" }, rangeGroupId),
      h("ul", null, rangeData.map(({ sourceId, color, rangeUrl, displayName, formattedDisplayName }) => {
        return (h("li", { class: "product-finder-result__item--commercial-status", key: sourceId },
          h("span", { class: "commercial-status-color", style: { 'background-color': color } }),
          displayName && !formattedDisplayName && (h("a", { class: "product-finder-result__link", href: rangeUrl }, displayName)),
          formattedDisplayName && (h("a", { class: "product-finder-result__link", href: rangeUrl, innerHTML: formattedDisplayName }))));
      }))));
  })));
};

const productAtozCss = ":host{display:block}.text_align__center{text-align:center}.align_self__center{align-self:center}.pes-select__input{display:block;width:100%}.display_flex{display:flex}.mt-8px{margin-top:8px}:host(:not([dir=\"rtl\"])) .mr-8px{margin-right:8px}:host([dir=\"rtl\"]) .mr-8px{margin-left:8px}.product-finder-result__heading{display:block;color:#3dcd58;font-size:2.5pxrem;line-height:2.5pxrem;margin-bottom:0.3em}.product-finder-result{column-count:1}@media screen and (min-width: 980px){.product-finder-result{column-count:4}}@media print{.product-finder-result{columns:1;column-count:4}}.product-finder-result ul{margin-bottom:2em}.product-finder-result li{position:relative;break-inside:avoid;break-inside:avoid-column}a{text-decoration:none;outline:0;background-color:transparent}.product-finder-result__item--commercial-status{display:flex;align-items:center}.product-finder-result__link{position:relative;color:#626469}.commercial-status-color{display:inline-block;width:10px;height:10px;border-radius:10px;flex-shrink:0}:host(:not([dir=\"rtl\"])) .commercial-status-color{margin-right:10px}:host([dir=\"rtl\"]) .commercial-status-color{margin-left:10px}.atoz_container{max-width:1200px;min-height:400px;padding-top:20px;margin-right:auto;margin-left:auto;padding-top:10px;color:#626469;font-size:0.8125pxrem;line-height:0.8125pxrem}@media screen and (max-width: 979px){.atoz_container{margin-left:16px;margin-right:16px}}.atoz_header__title{font-weight:normal;font-size:2.1875pxrem;line-height:2.8125pxrem;margin:5px auto 15px;color:#3dcd58;text-align:center}@media screen and (min-width: 980px){.atoz_header__title{font-size:2.625pxrem;line-height:3.125pxrem;margin-top:20px;margin-bottom:20px}}.atoz_inner__container{width:100%;max-width:1180px;margin-left:auto;margin-right:auto}@media screen and (min-width: 980px){.atoz_inner__container{padding-right:10px;padding-left:10px}}.atoz_filter{display:block;margin-top:2em;margin-bottom:2em;width:100%}@media screen and (min-width: 980px){.atoz_filter{display:table;margin-bottom:4em}}@media screen and (min-width: 980px){.atoz_filter__form{display:flex;width:100%;align-items:center;flex-wrap:wrap}}.atoz_filter__cell{display:flex;vertical-align:middle;white-space:nowrap}:host(:not([dir=\"rtl\"])) .atoz_filter__cell{padding-right:1em}:host([dir=\"rtl\"]) .atoz_filter__cell{padding-left:1em}@media screen and (max-width: 979px){.atoz_filter__cell{display:block;margin-bottom:0;margin-top:0.5em}}.atoz_filter__cell:not(:first-of-type){width:25%}@media screen and (min-width: 980px){[locale|=zh_CN] .atoz_filter__cell:not(:first-of-type){width:47.5%}}@media print{.atoz_filter__cell:not(:first-of-type){width:80%}:host(:not([dir=\"rtl\"])) .atoz_filter__cell:not(:first-of-type){float:left}:host([dir=\"rtl\"]) .atoz_filter__cell:not(:first-of-type){float:right}}.atoz_commercial__status__description{margin-top:13px}.atoz_commercial__status_color{display:inline-block;width:10px;height:10px;border-radius:10px;flex-shrink:0}:host(:not([dir=\"rtl\"])) .atoz_commercial__status_color{margin-right:10px}:host([dir=\"rtl\"]) .atoz_commercial__status_color{margin-left:10px}.product-finder-result{list-style:none}:host(:not([dir=\"rtl\"])) .product-finder-result{padding-left:0px}:host([dir=\"rtl\"]) .product-finder-result{padding-right:0px}.highlight-naming{font-weight:normal}.highlight-naming .accent{font-weight:bold}";

const ProductAtoZ = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.commercialChangeHandler = ({ detail: { selectedValue } }) => {
      this.selectedCommercialStatus = selectedValue;
      this.filterAToZRangeGroups();
    };
    this.brandChangeHandler = ({ detail: { selectedValue } }) => {
      this.selectedBrand = selectedValue;
      this.filterAToZRangeGroups();
    };
    this.defineSelectOptions = (optionsData, selectedKey = DEFAULT_SELECT_KEY) => {
      if (!optionsData)
        return [];
      return Object.entries(optionsData).map(([key, label]) => ({
        value: key,
        label,
        selected: key === selectedKey,
      }));
    };
    this._pageMainTitle = undefined;
    this.pageMainTitle = undefined;
    this._filterByLabel = undefined;
    this.filterByLabel = undefined;
    this._legacyColorLabel = undefined;
    this._preCommercializeLabel = undefined;
    this._endOfCommercializeLabel = undefined;
    this._rangeStatusColorMap = undefined;
    this.rangeStatusColorMap = undefined;
    this._noDataMessage = undefined;
    this.noDataMessage = '';
    this._commercialSelectOptions = undefined;
    this.commercialSelectOptions = undefined;
    this._brandSelectOptions = undefined;
    this.brandSelectOptions = undefined;
    this._aToZRangeItems = undefined;
    this.isLoading = false;
    this.rangeData = [];
    this.extendedRangeItems = [];
    this.selectedCommercialStatus = DEFAULT_SELECT_KEY;
    this.selectedBrand = DEFAULT_SELECT_KEY;
    this.allBrandOptions = undefined;
    this.commercialStatusLabelsArray = [];
    this.commercialSelectValues = [];
    this.brandSelectValues = [];
    this.el.dir = document.documentElement.dir || 'auto';
  }
  componentWillLoad() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    this.pageMainTitle = (_a = tryParse(this._pageMainTitle)) !== null && _a !== void 0 ? _a : this.pageMainTitle;
    this.filterByLabel = (_b = tryParse(this._filterByLabel)) !== null && _b !== void 0 ? _b : this.filterByLabel;
    this.commercialSelectOptions = (_c = tryParse(this._commercialSelectOptions)) !== null && _c !== void 0 ? _c : this.commercialSelectOptions;
    this.commercialSelectValues = this.defineSelectOptions(this.commercialSelectOptions);
    this.brandSelectOptions = (_d = tryParse(this._brandSelectOptions)) !== null && _d !== void 0 ? _d : this.brandSelectOptions;
    this.allBrandOptions = this.brandSelectOptions;
    this.brandSelectValues = this.defineSelectOptions(this.brandSelectOptions);
    this.rangeStatusColorMap = (_e = tryParse(this._rangeStatusColorMap)) !== null && _e !== void 0 ? _e : null;
    const commercialStatusColorsAndLabels = {
      rangeStatusColorMap: this.rangeStatusColorMap,
      endOfCommercializationLabel: (_f = tryParse(this._endOfCommercializeLabel)) !== null && _f !== void 0 ? _f : '',
      preCommercializationLabel: (_g = tryParse(this._preCommercializeLabel)) !== null && _g !== void 0 ? _g : '',
      legacyColorLabel: (_h = tryParse(this._legacyColorLabel)) !== null && _h !== void 0 ? _h : '',
    };
    this.commercialStatusLabelsArray = (_j = getCommercialStatusArray(commercialStatusColorsAndLabels)) !== null && _j !== void 0 ? _j : [];
    const parsedRangeItems = (_k = tryParse(this._aToZRangeItems)) !== null && _k !== void 0 ? _k : null;
    if (this.rangeStatusColorMap && parsedRangeItems) {
      this.extendedRangeItems = extendAToZRangeItemsWithColor(parsedRangeItems, this.rangeStatusColorMap);
      this.rangeData = this.extendedRangeItems;
    }
    this.noDataMessage = (_l = tryParse(this._noDataMessage)) !== null && _l !== void 0 ? _l : '';
  }
  filterAToZRangeGroups() {
    if (this.selectedCommercialStatus === DEFAULT_SELECT_KEY && this.selectedBrand === DEFAULT_SELECT_KEY) {
      this.rangeData = [...this.extendedRangeItems];
      this.brandSelectValues = this.defineSelectOptions(this.allBrandOptions);
      return this.rangeData;
    }
    this.rangeData = [...this.filterForCommercializeOrBrand()];
    this.brandSelectValues = this.defineSelectOptions(this.filterBrandByCommercialStatus(), this.selectedBrand);
  }
  showAllBrands() {
    return (this.selectedCommercialStatus === DEFAULT_SELECT_KEY
      || (!this.rangeData.length
        && this.selectedCommercialStatus !== DEFAULT_SELECT_KEY
        && this.selectedBrand !== DEFAULT_SELECT_KEY));
  }
  filterBrandByCommercialStatus() {
    if (this.showAllBrands())
      return this.allBrandOptions;
    const brandsAsArray = Object.values(this.allBrandOptions);
    const filteredArray = brandsAsArray.filter((brandName) => {
      return this.extendedRangeItems.some((rangeDataItem) => rangeDataItem.rangeData.some(({ brand, status }) => brand === brandName && status === this.selectedCommercialStatus));
    });
    const filteredResult = {};
    for (const [brandKey, brandValue] of Object.entries(this.allBrandOptions)) {
      if (brandValue === this.allBrandOptions[DEFAULT_SELECT_KEY] || filteredArray.includes(brandValue)) {
        filteredResult[brandKey] = brandValue;
      }
    }
    return filteredResult;
  }
  filterForCommercializeOrBrand() {
    return this.extendedRangeItems
      .filter((rangeCategoryData) => rangeCategoryData.rangeData.some((rangeData) => this.formAndFilterCondition(rangeData)))
      .map((rangeCategoryData) => {
      const filteredObject = Object.assign(Object.assign({}, rangeCategoryData), { rangeData: rangeCategoryData.rangeData.filter((rangeData) => this.formAndFilterCondition(rangeData)) });
      return filteredObject;
    });
  }
  formAndFilterCondition(rangeData) {
    const { status, brand } = rangeData;
    const { selectedCommercialStatus, selectedBrand } = this;
    if (selectedCommercialStatus !== DEFAULT_SELECT_KEY && selectedBrand !== DEFAULT_SELECT_KEY) {
      return status === selectedCommercialStatus && brand === selectedBrand;
    }
    if (selectedBrand === DEFAULT_SELECT_KEY) {
      return status === selectedCommercialStatus;
    }
    return brand === selectedBrand;
  }
  render() {
    return (h("div", { class: "atoz_container" }, this.pageMainTitle && (h("div", { class: "text_align__center" }, h("h1", { class: "atoz_header__title" }, this.pageMainTitle))), h("div", { class: "atoz_inner__container" }, this.commercialSelectValues && this.brandSelectValues && this.filterByLabel && (h("div", { class: "atoz_filter" }, h("form", { class: "atoz_filter__form" }, h("div", { class: "atoz_filter__cell" }, this.filterByLabel), h("div", { class: "atoz_filter__cell" }, h("pes-select", { class: "pes-select__input", hasFixedWidth: false, items: this.commercialSelectValues, onSelectedValue: this.commercialChangeHandler })), h("div", { class: "atoz_filter__cell" }, h("pes-select", { class: "pes-select__input", hasFixedWidth: false, items: this.brandSelectValues, onSelectedValue: this.brandChangeHandler }))), this.commercialStatusLabelsArray.map((commercialStatusObject) => {
      if (!commercialStatusObject
        || !commercialStatusObject.color
        || !commercialStatusObject.labelName) {
        return null;
      }
      return (h("div", { class: "atoz_commercial__status__description" }, h("span", { class: "atoz_commercial__status_color", style: { 'background-color': commercialStatusObject.color } }), commercialStatusObject.labelName));
    }))), this.rangeData.length > 0 && !this.isLoading && (h(ProductAtoZRanges, { rangesData: this.rangeData })), !this.isLoading && this.rangeData.length === 0 && this.noDataMessage && (h("ul", { class: 'product-finder-result' }, h("li", null, this.noDataMessage))), this.isLoading && (h("div", null, h("pes-preloader", null))))));
  }
  get el() { return getElement(this); }
};
ProductAtoZ.style = productAtozCss;

export { ProductAtoZ as pes_product_atoz };
